import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classNames from 'classnames';

import ImageWithCorner from 'apps/fops/components/fopPartials/ImageWithCorner';
import ProductWarning from 'apps/fops/containers/fopPartials/ProductWarning';
import QuantityInput from 'apps/quantityControls/components/QuantityInput';

import { gtm } from 'apps/gtm';
import { getProductDetailsLink } from 'apps/products/links';
import { priceFormat } from 'apps/products/utils/priceFormat';

import Locations from 'apps/basket/models/Locations';
import ProductWarnings from 'apps/products/models/ProductWarnings';

export default class TrolleyMenuItem extends PureComponent {
  static propTypes = {
    basketItem: PropTypes.object.isRequired,
    betaFeatures: PropTypes.array.isRequired,
    closeTrolleyMenu: PropTypes.func.isRequired,
    product: PropTypes.object,
    productWarnings: PropTypes.arrayOf(PropTypes.oneOf(Object.values(ProductWarnings))),
    changeBasketQuantity: PropTypes.func.isRequired,
  };

  static triggerTrolleyEvent(product, quantityDiff) {
    const productData = {
      gtmPageType: 'Trolley sidebar', // TODO this should be specific to page e.g. 'Offers'
      quantity: Math.abs(quantityDiff),
      section: 'Trolley sidebar',
      product,
    };

    gtm.trigger(quantityDiff > 0 ? 'gtm:addToTrolley' : 'gtm:removeFromTrolley', productData);
  }

  onQuantitySubmit = (quantityDiff, analyticsData) => {
    const { changeBasketQuantity, product } = this.props;
    const { sku } = product;
    changeBasketQuantity({
      items: { [sku]: quantityDiff },
      location: Locations.TROLLEY_SIDEBAR,
      analyticsContextData: analyticsData,
    });
    TrolleyMenuItem.triggerTrolleyEvent(product, quantityDiff);
  };

  render() {
    const { product, productWarnings, basketItem, betaFeatures } = this.props;

    const analyticsContextData = {
      product,
      section: {
        attributes: { type: 'TROLLEY' },
        id: 'TROLLEY_ITEM',
      },
      pageType: Locations.TROLLEY_SIDEBAR,
    };

    if (!product) {
      return (
        <li className="hd-trolleyMenuItem hd-trolleyMenuItem--empty" />
      );
    }

    const hasQuantity = basketItem.quantity > 0;

    return (
      <li
        className={classNames(
          'hd-trolleyMenuItem',
          {
            'hd-trolleyMenuItem--fade': !hasQuantity,
          }
        )}
      >
        <Link
          to={getProductDetailsLink({ product, betaFeatures })}
          onClick={this.props.closeTrolleyMenu}
          className="hd-trolleyMenuItem__link"
        >
          <div className="hd-trolleyMenuItem__imgWrapper">
            <ImageWithCorner product={product} />
          </div>
          <div className="hd-trolleyMenuItem__content">
            <div className="hd-trolleyMenuItem__name">
              <span className="hd-trolleyMenuItem__description">{product.name}</span>
              <span className="hd-trolleyMenuItem__weight">{product.catchWeight}</span>
            </div>
            <ProductWarning className="hd-trolleyMenuItem__errorMessage" product={product} />
            <div className="hd-trolleyMenuItem__promotion">{basketItem.promotionName}</div>
          </div>
        </Link>
        <div className="fop-add-trolley">
          <span className="fop-price">{
            hasQuantity ?
              priceFormat({ value: basketItem.totalPrice })
              : priceFormat({ value: basketItem.pricePerUnit })
            }
          </span>
          <div className="fop-add-default">
            <QuantityInput
              analyticsContextData={analyticsContextData}
              isUpdating={basketItem.isUpdating}
              onQuantitySubmit={this.onQuantitySubmit}
              productWarning={Boolean(productWarnings && productWarnings.length)}
              quantity={basketItem.quantity}
              sku={basketItem.sku}
            />
          </div>
        </div>
        <div className="fop-quantity-row">
          <span className="fop-price">{priceFormat({ value: basketItem.pricePerUnit })}</span>
          <span className="fop-quantity-price">
            {basketItem.quantity} x <strong>{priceFormat({ value: basketItem.pricePerUnit })}</strong>
          </span>
        </div>
      </li>
    );
  }
}
